import { useState, useEffect } from 'react';

export default function useCapacitorDevicePlugin() {
  const [isNativeApp] = useState(RUNTIME_ENV === 'native');
  const [appVersion, setAppVersion] = useState('');
  useEffect(() => {
    (async () => {
      if (RUNTIME_ENV === 'native') {
        try {
          const { Device } = await import('@capacitor/device');
          const info = await Device.getInfo();
          if (info.platform !== 'web') {
            const { App } = await import('@capacitor/app');
            const app = await App.getInfo();
            setAppVersion(app.version);
            console.log('useCapacitorDevicePlugin check: ', true);
          }
        } catch (e) {
          console.log('useCapacitorDevicePlugin check: ', e);
        }
      }
    })();
  }, []);
  return { isNativeApp, appVersion };
}
